import JSZip from 'jszip'

const fileExtensionRegex = /\.\w+$/

export interface PreparedFile {
  fileName: string
  url: string
  fileType: string | null
}

export async function extractDocumentFiles(
  responseBlob: string
): Promise<PreparedFile[]> {
  const blob = new Blob([responseBlob], { type: 'application/zip' })
  const zip = await JSZip.loadAsync(blob)
  const fileNames = Object.keys(zip.files)

  const files: PreparedFile[] = []
  for (const fileName of fileNames) {
    // Uploads only ever produce flat file names (see useUploadChecklistDocument.ts),
    // so zip.file() returning null here - which only happens for zip-format
    // directory entries - should not happen.
    const fileContent = await zip.file(fileName)!.async('uint8array')
    const fileType = getFileType(fileName)
    const fileBlob = fileType
      ? new Blob([fileContent], { type: fileType })
      : new Blob([fileContent])
    files.push({
      fileName,
      url: window.URL.createObjectURL(fileBlob),
      fileType,
    })
  }
  return files
}

// A file with no extension is treated the same as an unrecognized one
// (fileType: null, download-only) rather than throwing and aborting the
// whole batch over one oddly-named file.
function getFileType(fileName: string): string | null {
  const fileExtensionMatch = fileName.match(fileExtensionRegex)
  if (!fileExtensionMatch) {
    return null
  }
  const extension = fileExtensionMatch[0].toLowerCase()
  switch (extension) {
    case '.pdf':
      return 'application/pdf'
    case '.txt':
    case '.csv':
      return 'text/plain'
    case '.png':
      return 'image/png'
    case '.jpg':
    case '.jpeg':
      return 'image/jpeg'
    case '.doc':
    case '.xls':
    case '.xlsx':
    case '.docx':
    case '.zip':
    default:
      return null
  }
}
